import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {HelpItem} from '../type';

interface HelpState {
  helpData?: HelpItem[];
  helpId: string;
  helpPage: number;
  totalCount: number;
}

export const helpSlice = createSlice({
  name: 'help',
  initialState: {
    helpData: [],
    helpId: '',
    helpPage: 1,
    totalCount: 0,
  } as HelpState,
  reducers: {
    setHelpData: (state, action: PayloadAction<HelpItem[]>): void => {
      state.helpData = action.payload;
    },
    setHelpId: (state, action: PayloadAction<string>): void => {
      state.helpId = action.payload;
    },
    setHelpPage: (state, action: PayloadAction<number>): void => {
      state.helpPage = action.payload;
    },
    setTotalCount: (state, action: PayloadAction<number>): void => {
      state.totalCount = action.payload;
    },
  },
});

export const {setHelpData, setHelpId, setHelpPage, setTotalCount} =
  helpSlice.actions;
